import { useGetUserSessionQuery } from '@/hooks/queries/useGetUserSessionQuery';
import { UserSession } from '@/hooks/queries/useGetUserSessionQuery/types';

export const useCompany = () => {
  const { data } = useGetUserSessionQuery();
  return (data?.company || {}) as NonNullable<UserSession['company']>;
};
